import service from "../api/services/utilService";

const countryList = JSON.parse(localStorage.getItem("countryList"));

export default {
    namespaced: true,
    state: {
        countryList: countryList,
    },

    mutations: {
        countryList(state, response) {
            localStorage.setItem("countryList", JSON.stringify(response));
            state.countryList = response;
        },
    },
    actions: {
        getCountryList(context, reqData) {
            return service.getCountryList(reqData).then((response = {}) => {
                context.commit(
                    "countryList",
                    response.responseData.countryList
                );
                return response.responseData.countryList;
            });
        },
        getInstituteDataTypes(context, reqData) {
            return service
                .getInstituteDataTypes(reqData)
                .then((response = {}) => {
                    return response.responseData;
                });
        },
        getDataTreeWithLevel(context, reqData) {
            return service
                .getDataTreeWithLevel(reqData)
                .then((response = {}) => {
                    return response.responseData.data;
                });
        },
        getDataTreeWithLevelPublic(context, reqData) {
            return service
                .getDataTreeWithLevelPublic(reqData)
                .then((response = {}) => {
                    return response.responseData.data;
                });
        },
        getClasses(context) {
            return service.getClasseses().then((response = {}) => {
                return response.responseData;
            });
        },
        getTestTarget(context, reqData) {
            return service.getTestTarget(reqData).then((response = {}) => {
                return response.responseData.data;
            });
        },
        getRefData(context, reqData) {
            return service.getRefData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getComprehensionSubtypes(context, reqData) {
            return service
                .getComprehensionSubtypes(reqData)
                .then((response = {}) => {
                    return response.responseData.data;
                });
        },
        getSubTypeList(context, reqData) {
            return service.getSubTypeList(reqData).then((response = {}) => {
                return response.responseData.data;
            });
        },
        getTestSubTypes(context, reqData) {
            return service.getTestSubTypes(reqData).then((response = {}) => {
                return response.responseData.data;
            });
        },
        getAllModules(context, reqData) {
            return service.getAllModules(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
		getDataTree(context,reqData) {
			return service.getDataTree(reqData).then((response={})=>{
				return response.responseData
			})
		},
		getTestPatterns(context,reqData) {
			return service.getTestPatterns(reqData).then((response={})=>{
				return response.responseData
			})
		},
        getTestTypes(context,reqData) {
			return service.getTestTypes(reqData).then((response={})=>{
				return response.responseData
			})
		},
        getCenters(context,reqData) {
			return service.getCenters(reqData).then((response={})=>{
				return response.responseData
			})
		},
        getBatchesByCenters(context,reqData) {
			return service.getBatchesByCenters(reqData).then((response={})=>{
				return response.responseData
			})
		},
        getSubscriptionImpact(context,reqData){
            return service.getSubscriptionImpact(reqData).then((response={})=>{
                return response.responseData
            })   
        },
        answerFeedback(context,reqData){
            return service.answerFeedback(reqData).then((response={})=>{
                return response.responseData
            })   
        },
        getUserFeedbackQuestion(context,reqData){
            return service.getUserFeedbackQuestion(reqData).then((response={})=>{
                return response.responseData
            })   
        },
        getMYTDataTree(context,reqData) {
			return service.getMYTDataTree(reqData).then((response={})=>{
				return response.responseData
			})
		},
        getMYTRefData(context, reqData) {
            return service.getMYTRefData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getMYTTestPatterns(context, reqData) {
            return service.getMYTTestPatterns(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getMYTSubTypeList(context, reqData) {
            return service.getMYTSubTypeList(reqData).then((response = {}) => {
                return response.responseData.data;
            });
        },
        getPriceDetailsMyt(context, reqData) {
            return service.getPriceDetailsMyt(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getBillingDetailsMYT(context, reqData){
            return service.getBillingDetailsMYT(reqData).then((response = {}) => {
                return response.responseData;
            })
        },
        getAllQuestionsCount(context, reqData){
            return service.getAllQuestionsCount(reqData).then((response = {}) => {
                return response.responseData;
            })
        },
        getOMRPattern(context, reqData) {
            return service.getOMRPattern(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
    },
};
